import React, { useState } from 'react'
import { candidatsData } from '../maires.yml'
import styles from './candidats-cards.m.scss'

export const CandidatsCards = () => {
  // candidatsData.sort(() => 0.5 - Math.random())
  const [candidats] = useState(candidatsData)

  return (
    <div className={styles.container}>
      {candidats.map((candidat: Candidat) => (
        <div className={styles.card} key={`candidat-${candidat.id}`}>
          <div
            className={styles.portrait}
            style={{
              backgroundImage: `url(${require(`./candidats-pictures/${candidat.id}.jpg`)})`
            }}
          >
            {candidat.groupe.couleur && (
              <div className={styles.groupe}>
                <i
                  style={{ backgroundColor: `#${candidat.groupe.couleur}` }}
                  className={styles.couleurParti}
                />{' '}
                {candidat.groupe.abbr}
              </div>
            )}

            {/* <div className={styles.unchanged}>
              {!candidat.new && (
                <>
                  <i
                    className='icon redo alternate'
                    style={{ height: 'auto' }}
                  />
                  <span>Inchangé</span>
                </>
              )}
            </div> */}
          </div>
          <div className={styles.content}>
            <div className={styles.name}>{candidat.municipality}</div>
            <div className={styles.infos}>
              <div>{candidat.nom}</div>
              {/* <div>{candidat.groupe.nom}</div> */}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
